import { SELECT_CATEGORY, UPDATE_DATA_STATE } from 'redux/constants/fetchedData';

const initState = {
  storeData:{},
  logo: {},
  timings: [],
  categories: [],
  categoryLoading:false,
  selectedCategory:{},
  categoryProducts: {},
  product: {},
  countries:[],
  cities: [],
  areas: [],
  pickups: [],
  selectedBranch: {},
  searchResults: [],
  orderCheckStatus: {},
  makeOrderResult:{},
  checkedOrderData:{},
  orderCheckStatusLoading:false,
  promotionBanners: {},
  promotions: [],
  pinnedBox: []
}

const FetchedData = (state = initState, action) => {
	switch (action.type) {
		case UPDATE_DATA_STATE:
			return {
				...state,
        ...action.payload,
			}
    case SELECT_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
      }
		default:
			return state;
	}
}

export default FetchedData;